import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "./locales/en/translation.json";
import itTranslation from "./locales/it/translation.json";

/**
 * Italiano e inglese sono compilati dentro il bundle: sono le lingue del
 * traffico reale e cosi' la prima schermata non aspetta nessuna richiesta.
 * Tutto il resto (francese, tedesco, spagnolo, e i namespace pesanti come il
 * testo legale) viene caricato con un import dinamico, quindi finisce in un
 * file a parte che il browser scarica solo se serve davvero.
 */
const resources = {
  en: { translation: enTranslation },
  it: { translation: itTranslation },
};

const LINGUE = ["it", "en", "fr", "de", "es"];

const caricatore = {
  type: "backend",
  init: () => {},
  read(lingua, namespace, callback) {
    import(
      /* webpackChunkName: "lingua" */
      `./locales/${lingua}/${namespace}.json`
    )
      .then((modulo) => callback(null, modulo.default))
      .catch((errore) => callback(errore, null));
  },
};

i18n
  .use(caricatore)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Serve con resources gia' presenti: dice a i18next di andare comunque
    // a cercare dal backend cio' che non trova qui dentro.
    partialBundledLanguages: true,
    supportedLngs: LINGUE,
    nonExplicitSupportedLngs: true, // "de-DE" ricade su "de"
    fallbackLng: "en",
    ns: ["translation"],
    defaultNS: "translation",
    debug: false,
    interpolation: { escapeValue: false },
    detection: {
      // Prima la scelta salvata, poi la lingua del browser: un ospite tedesco
      // arriva direttamente in tedesco invece che in inglese.
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    react: { useSuspense: true },
  });

// L'attributo lang del documento deve seguire la lingua scelta, per i lettori
// di schermo e per i motori di ricerca.
const aggiornaLangDocumento = (lingua) => {
  document.documentElement.setAttribute("lang", lingua);
};

aggiornaLangDocumento(i18n.resolvedLanguage || i18n.language || "en");
i18n.on("languageChanged", aggiornaLangDocumento);

export const lingueSupportate = LINGUE;
export default i18n;
